import { Badges, LI } from '../../../AbstractElements'
import { SidebarIconProp } from '../../../Types/ThemeCustomizerTypes'
import { Stroke } from '../../../Utils/Constants'
import CommonUL from './CommonUL'

const StrokeIcon = ({ handleSideBarIconType, sideBarIconType }: SidebarIconProp) => {
  return (
    <LI data-attr="stroke-svg" className={`normal-sidebar border-0 ${sideBarIconType === "stroke" ? "active" : ""}`} onClick={() => handleSideBarIconType("stroke")}>
      <div className="header bg-light">
        <CommonUL />
      </div>
      <div className="body bg-light">
        <Badges color="primary">{Stroke}</Badges>
      </div>
    </LI>
  )
}

export default StrokeIcon